import { Dispatch, SetStateAction, useCallback, useState } from "react"
import { FaroInsightsWrapper } from "@/grafana-faro"
import { UpdatePatientWizard } from "@/modules/inbound-wizard"
import useCallContextStore from "@/stores/useCallContextStore"

export const useOpenPatientInboundCall = (setPatientQuery?: Dispatch<SetStateAction<string>>) => {
  const country = useCallContextStore((state) => state.country)
  const callLineCode = useCallContextStore((state) => state.callLineCode)
  const record = useCallContextStore((state) => state.record)
  const callId = useCallContextStore((state) => state.callID)

  const [selectedPatientId, setSelectedPatientId] = useState("")
  const [selectedPatientName, setSelectedPatientName] = useState("")

  // Take-over is requested on "Open medical record", not when opening the wizard.
  const openPatientInboundCall = useCallback(
    (patientId: string, patientName: string) => {
      FaroInsightsWrapper.pushEvent("ibc_initialize_ibc", {
        record: record ?? "",
        callLineCode: callLineCode,
        country: country,
        callID: callId ?? "",
      })
      setSelectedPatientId(patientId)
      setSelectedPatientName(patientName)
    },
    [callId, callLineCode, country, record],
  )

  const patientInboundCallDialog = (
    <UpdatePatientWizard
      defaultCountry={country}
      patientId={selectedPatientId}
      patientName={selectedPatientName}
      open={Boolean(selectedPatientId)}
      onOpenChange={(isOpen) => {
        if (!isOpen) setSelectedPatientId("")
      }}
      setPatientQuery={setPatientQuery}
    />
  )

  return { openPatientInboundCall, patientInboundCallDialog }
}
